import { api } from "@/api/axios.ts";
import { ApiOperationResult } from "@/types/common.types.ts";
import {
  ApiTimeOffApproveRequest,
  ApiTimeOffConfirmationCommentUpdate,
  ApiTimeOffLogFull,
  ApiTimeOffLogFullCheck,
  ApiTimeOffLogFullDetails,
  ApiTimeOffRequestSave,
} from "@/types/time-off/time-off.types.ts";

export const apiTimeOffRequest = {
  getById: (id: number) => {
    return api.get<ApiTimeOffLogFullDetails>(`/api/v1/time-off/requests/${id}`);
  },
  create: (payload: ApiTimeOffRequestSave) => {
    return api.post<ApiTimeOffLogFull>("/api/v1/time-off/requests", payload);
  },
  update: (id: number, payload: ApiTimeOffRequestSave) => {
    return api.put<ApiTimeOffLogFull>(`/api/v1/time-off/requests/${id}`, payload);
  },
  cancel: (id: number) => {
    return api.post<ApiOperationResult>(`/api/v1/time-off/requests/${id}/cancel`, {});
  },
  approve: (id: number, payload: ApiTimeOffApproveRequest) => {
    return api.post<ApiOperationResult>(`/api/v1/time-off/requests/${id}/approve`, payload);
  },
  reject: (id: number, payload: ApiTimeOffApproveRequest) => {
    return api.post<ApiOperationResult>(`/api/v1/time-off/requests/${id}/reject`, payload);
  },
  updateConfirmationComment: (id: number, body: ApiTimeOffConfirmationCommentUpdate) => {
    return api.put<ApiOperationResult>(
      `/api/v1/time-off/requests/${id}/confirmation/comment`,
      body
    );
  },
  delete: (id: number) => {
    return api.delete<ApiOperationResult>(`/api/v1/time-off/requests/${id}`);
  },
  check: (payload: ApiTimeOffRequestSave) => {
    return api.post<ApiTimeOffLogFullCheck>("/api/v1/time-off/requests/check", payload);
  },
};
